module.exports = __webpack_public_path__ + "static/img/digitalCampus.4bd56a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/almaMater/digitalCampus.png
// module id = 61Dh
// module chunks = 1